export function hasNumberInString(myString) {
  return /\d/.test(myString);
}

export function replaceNumberInString(string, sub) {
  return string.replace(/-?\d+\.\d+/g, sub).replace(/\d+/g, sub)
}

function addHours(numOfHours, date = new Date()) {
  date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);

  return date;
}

export function verifyQuarenteneNPS(datetime){
  const then = new Date(datetime);
  let now = new Date();
  now = addHours(3, now)

  const msBetweenDates = Math.abs(then.getTime() - now.getTime());

  // 👇️ convert ms to hours                  min  sec   ms
  const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

  const hoursQuarantine = Number(process.env.REACT_APP_NPS_QUARANTINE);

  if (hoursBetweenDates >= hoursQuarantine) {
    return true
  }
  return false;
}

export function verifyDifferenceTime(datetime, valueTime){
  const then = new Date(datetime);
  let now = new Date();

  const msBetweenDates = Math.abs(then.getTime() - now.getTime());

  // 👇️ convert ms to hours                  min  sec   ms
  const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

  if (hoursBetweenDates >= valueTime) {
    return true
  }
  return false;
}

export function formatCNPJ(cnpj) {
  // remove any non-numeric characters
  cnpj = cnpj.replace(/[^\d]+/g, '');

  // check the length of the input
  if (cnpj.length !== 14) {
    return cnpj;
  }

  // format the input
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function checkSubString(value, sub) {
  const includeString = value.includes(sub);
  if (includeString) {
      return true
  }
  return false
}

export function extractDateFromMessage(message) {
  const dateRegex = /(\d{2}\/\d{2}\/\d{4})/;
  const matches = message.match(dateRegex);

  if (matches && matches.length > 0) {
    const foundDate = matches[0];
    return foundDate;
  } else {
    return null;
  }
}

export function reformatDateString(inputDateString) {
  const match = inputDateString.match(/(\d{2})\/(\d{2})\/(\d{4})/);

  if (match) {
    const [, day, month, year] = match;
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  } else {
    return null;
  }
}

export function formatCurrency(value) {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
}

export function formatDateTimeWithOffset(dateTimeString) {
  const months = [
    'janeiro', 'fevereiro', 'março', 'abril',
    'maio', 'junho', 'julho', 'agosto',
    'setembro', 'outubro', 'novembro', 'dezembro'
  ];

  const dateTime = new Date(dateTimeString);

  const day = dateTime.getDate();
  const month = months[dateTime.getMonth()];
  const time = dateTime.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

  return `${day}/${month}, às ${time}hs`;
}
